import { render, staticRenderFns } from "./template-vak.vue?vue&type=template&id=ad837192&scoped=true&"
import script from "./template-vak.vue?vue&type=script&lang=js&"
export * from "./template-vak.vue?vue&type=script&lang=js&"
import style0 from "./template-vak.vue?vue&type=style&index=0&id=ad837192&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad837192",
  null
  
)

export default component.exports